<template>
  <div class="info-block-root">
    <div class="info-block-row-title">
      <span>{{ $t('b2b|common|label|rate') }} {{ coin?.title }}</span>
      <base-popover popover-type="tooltip">
        <template #content>
          {{ $t('WithdrawToCard | rateTooltip', [rateTimeToLive]) }}
        </template>
      </base-popover>
    </div>

    <div class="info-block-value">
      <circle-loader
        v-if="!isFeeTimeToLiveTooMuch && isRateVisible"
        :value="0"
        :colors="['var(--text-5)', 'var(--brand)']"
        :duration="rateTimeToLive * 1000"
        direction="right"
      />
      <span class="flex gap-1" data-cy="withdraw-to-card-rate-amount">
        <span v-if="isRateVisible">
          {{ formatFiatAmount(rate) }}
        </span>
        <span v-else>—</span>
      </span>
    </div>
  </div>
</template>

<script>
import { BasePopover } from '@emcd-shared/base-popover'
import Utils from '@emcd-shared/utils/formatters'
import CircleLoader from '@/shared/ui/CircleLoader/CircleLoader.vue'

export default {
  name: 'WithdrawalToCardInfo',

  components: {
    BasePopover,
    CircleLoader,
  },

  props: {
    // If we right now is loading a new rate value
    isLoadingRate: {
      type: Boolean,
      default: false,
    },
    // Exchange rate for coin to fiat withdraw
    rate: {
      type: Number,
    },
    // Time to update withdraw rate
    rateTimeToLive: {
      type: Number,
    },
    // Selected coin - object with full info from coin/config
    coin: {
      type: Object,
    },
    // Information about selected fiat currency
    fiat: {
      type: Object,
    },
  },

  computed: {
    // We won't show progress circle if fee TTL is higher than threshold
    isFeeTimeToLiveTooMuch() {
      return this.rateTimeToLive > 120
    },

    // Flag - to show fee value or just placeholder for fee
    isRateVisible() {
      return !this.isLoadingRate
    },
  },

  methods: {
    formatFiatAmount(value) {
      if (value === undefined || this.fiat === undefined) return ''
      return Utils.formatCurrency(
        value,
        this.fiat?.value,
        2,
        false,
        'floor',
        {},
        this.$i18n.locale
      )
    },
  },
}
</script>

<style scoped lang="scss">
.info-block-root {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
}

.info-block-row-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: var(--text-4);
}

.info-block-value {
  display: flex;
  align-items: center;
  justify-self: flex-end;
  gap: 5px;
  font-size: 16px;
  font-weight: 500;
  color: var(--text-1);
}
</style>
